export { useRedirectVerifiedCustomers } from './use-redirect-verified-customers';
